export class TrainAdjustListController {
    _component;

    _bind(comp) {
        this._component = comp;
    }

    initSortable() {
        this._component._initSortable();
    }
}
